import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Card, StyledBody } from "baseui/card";
import { Button } from "baseui/button";
import { Input } from "baseui/input";
import { Block } from "baseui/block";
import { ArrowLeft } from "baseui/icon";
import Logo from "../../../assets/hmlogo.webp";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage(null);
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${apiUrl}/api/auth/forgot-password`, {
        username: email.trim(),
      });

      if (response.data.success) {
        setMessageType("success");
        setMessage(response.data.message);
        setEmail("");
      } else {
        setMessageType("error");
        setMessage(response.data.message || "Failed to send reset link.");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setMessageType("error");

      if (error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage("An error occurred. Please try again later.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Block
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Block width={["30%"]}>
        <Card>
          <Block
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding="scale200"
          >
            <img
              src={Logo}
              style={{ backgroundColor: "white" }}
              className="img-fluid"
              alt="Holmes Motors Logo"
            />
          </Block>

          <StyledBody>
            <h2 style={{ textAlign: "center" }}>Reset Your Password</h2>
            <p
              style={{
                textAlign: "center",
                fontSize: "14px",
                marginBottom: "16px",
              }}
            >
              Enter your email address and we'll send you a link to reset your
              password.
            </p>

            <form onSubmit={handleSubmit}>
              <Block marginBottom="scale600">
                <label htmlFor="email">Email Address</label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                />
              </Block>

              <Button
                type="submit"
                isLoading={isSubmitting}
                disabled={isSubmitting || !email}
                overrides={{
                  BaseButton: {
                    style: {
                      width: "100%",
                      marginBottom: "16px",
                    },
                  },
                }}
              >
                {isSubmitting ? "Sending..." : "Send Reset Link"}
              </Button>

              {message && (
                <div
                  style={{
                    color: messageType === "success" ? "green" : "red",
                    textAlign: "center",
                    marginTop: "12px",
                  }}
                >
                  {message}
                </div>
              )}
            </form>

            <Block
              display="flex"
              justifyContent="center"
              alignItems="center"
              marginTop="scale500"
            >
              <Button
                kind="tertiary"
                onClick={() => navigate("/")}
                startEnhancer={() => <ArrowLeft size={20} />}
                overrides={{
                  BaseButton: {
                    style: {
                      textDecoration: "none",
                    },
                  },
                }}
              >
                Back to Login
              </Button>
            </Block>
          </StyledBody>
        </Card>
      </Block>
    </Block>
  );
}

export default ForgotPassword;
